import { defaultTheme, styled } from '@automata/mui-theme';
import { SxProps, Theme } from '@mui/material/styles';
import { FC, ReactNode } from 'react';

import { InfoIconPopover, type InfoIconPopoverProps } from '../InfoIconPopover';
import { Typography } from '../Typography';

const Asterisk = styled('span')`
  color: ${(p) => p.theme.palette.error.main};
  vertical-align: super;
`;

export interface FormLabelProps extends Partial<InfoIconPopoverProps> {
  children: ReactNode;
  htmlFor?: string;
  id?: string;
  required?: boolean;
  sx?: SxProps<Theme>;
}

export const FormLabel: FC<FormLabelProps> = ({
  children,
  htmlFor,
  id,
  required,
  sx,
  infoPopover,
  infoPopoverMaxWidth,
  infoPopoverAnchorOrigin,
  infoPopoverTransformOrigin,
}) => {
  return (
    <Typography
      alignItems="center"
      color={defaultTheme.palette.text.primary}
      component="label"
      lineHeight={2}
      display="flex"
      gap={0.5}
      htmlFor={htmlFor}
      id={id}
      pb={0.5}
      pt={1}
      sx={sx}
      variant="overline"
    >
      {children}
      {required && <Asterisk>*</Asterisk>}
      {infoPopover && (
        <InfoIconPopover
          infoPopover={infoPopover}
          infoPopoverMaxWidth={infoPopoverMaxWidth}
          infoPopoverAnchorOrigin={infoPopoverAnchorOrigin}
          infoPopoverTransformOrigin={infoPopoverTransformOrigin}
        />
      )}
    </Typography>
  );
};
